import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'date-time-short',
})
export class ShortDateTimePresentationPipe implements PipeTransform {
  constructor() {}

  public transform(value: any, ...args: any[]) {
    if (
      value === '0001-01-01T00:00:00+00:00' ||
      value === '1900-01-01T00:00:00+00:00' ||
      value === null ||
      value === undefined ||
      value === ''
    ) {
      return '-';
    }
    const date = new Date(value);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${day}/${month} ${hours}:${minutes}`;
  }
}
